/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo, useState, useEffect, useMemo, useRef, useCallback } from "react";

// antd:
import { Cascader, Skeleton } from "antd";

import type { CascaderProps } from "antd";

// import type * as CSS from "csstype";

interface Option {
  value:string;
  label:string;
  disabled?:boolean;
  children?:Option
}

// Redux-hooks:
// import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";

// Reducers:
// import { getDict, getTheme, getLng } from "../../libs/reducer.ts";

const { rz } = window;

type componentProps = {
  params:{
    value:string | string[] | {[key:string]:any}[] | undefined,
    values?:(itms:string[] | {[key:string]:any}[] | undefined) => Promise<Array<Option>>,
    onValueChange:(newValue:string | string[] | {[key:string]:any}[] | undefined) => void,
    specialCellEditorOnChange?:(newValue:string | string[] | {[key:string]:any}[] | undefined) => void,
    stopEditing?:() => void, saveToDatabase?:boolean, node:any,
    column:{[key:string]:any},
    appkey?:string,
    aggridkey?:string,
    gridRef?:any,
    fullPath?:string,
    lng?:string,
    user?:{login:string, groups:string[], name?:string},
    keyField?:string,
    parentField?:string,
    titleField?:string,
    eventKey?:string,
    rowIndex?:number | string,
    items?:Option[],
    options?:Option[],
    allowClear?:boolean,
    autoFocus?:boolean,
    placeholder?:string,
    multiple?:boolean,
    changeOnSelect?:boolean,
    tooltip?:string,
    safe?:boolean
  }
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

// eslint-disable-next-line react/display-name
export default memo((params:componentProps) => {
  const {
    appkey, aggridkey, gridRef, fullPath, lng, user, keyField, parentField, titleField, value, values, onValueChange, eventKey,
    rowIndex, column, options, items, multiple, changeOnSelect, allowClear, autoFocus, tooltip, placeholder,
    specialCellEditorOnChange, stopEditing, node, saveToDatabase, safe
  } = params;
  // Debug:
  // console.log({ appkey, value, onValueChange, eventKey, rowIndex, column, items });

  const refCascade = useRef(null);

  const [loading, setLoading] = useState(true);
  const [cascaderTree, setTree] = useState<Array<{[key:string]:any}>>([]);
  const [allRows, setAllRows] = useState<Array<{[key:string]:any}>>((options || items || []));

  useEffect(() => {
    if (!values) {
      setAllRows((options || items || []));
      const userItems = rz.cascaderPath({allRows: (options || items || []), method: "tree", keyField: keyField || "value", parentField: parentField || "parent", titleField: titleField || "title", lng});
      setTree(userItems as Array<{[key:string]:any}>); setLoading(false);
      return;
    }
    if (rz.isArray(values)) {
      setAllRows(values);
      const userItems = rz.cascaderPath({allRows: values, method: "tree", keyField: keyField || "value", parentField: parentField || "parent", titleField: titleField || "title", lng});
      setTree(userItems as Array<{[key:string]:any}>); setLoading(false);
      return;
    }
    if (appkey && rz.isString(values) && window[appkey] && window[appkey][values]) {
      if (rz.isPromise(window[appkey][values])) {
        window[appkey][values]({appkey, aggridkey, keyField, parentField, titleField, fullPath, lng, column, rowIndex, safe}).then((allRows1) => {
          setAllRows(allRows1 || []);
          const userItems = rz.cascaderPath({allRows: allRows1 || [], method: "tree", keyField: keyField || "value", parentField: parentField || "parent", titleField: titleField || "title", lng});
          setTree(userItems as Array<{[key:string]:any}>); setLoading(false);
        }).catch((err) => { console.log(err) });
      }
      else if (rz.isFunction(window[appkey][values])) {
        const allRows1 = window[appkey][values]({appkey, aggridkey, keyField, parentField, titleField, fullPath, lng, column, rowIndex, safe});
        setAllRows(allRows1 || []);
        const userItems = rz.cascaderPath({allRows: allRows1 || [], method: "tree", keyField: keyField || "value", parentField: parentField || "parent", titleField: titleField || "title", lng});
        setTree(userItems as Array<{[key:string]:any}>); setLoading(false);
      }
    }
    else if (rz.isPromise(values)) {
      values({appkey, aggridkey, keyField, parentField, titleField, fullPath, lng, column, rowIndex, safe}).then((allRows1) => {
        setAllRows(allRows1 || []);
        const userItems = rz.cascaderPath({allRows: allRows1 || [], method: "tree", keyField: keyField || "value", parentField: parentField || "parent", titleField: titleField || "title", lng});
        setTree(userItems as Array<{[key:string]:any}>); setLoading(false);
      }).catch((err) => { console.log(err) });
    }
    else if (rz.isFunction(values)) {
      const allRows1 = values({appkey, aggridkey, keyField, parentField, titleField, fullPath, lng, column, rowIndex, safe});
      setAllRows(allRows1 || []);
      const userItems = rz.cascaderPath({allRows: allRows1 || [], method: "tree", keyField: keyField || "value", parentField: parentField || "parent", titleField: titleField || "title", lng});
      setTree(userItems as Array<{[key:string]:any}>); setLoading(false);
    }
  }, [aggridkey, appkey, column, fullPath, items, lng, keyField, options, rowIndex, values, parentField, titleField, safe]);

  const initValues = useMemo(() => { // Always returnes only [keys]
    let rowData:Array<{[key:string]:any}> = [];
    if (rz.isString(value)) {
      rowData = allRows.filter((rr) => (rr[keyField] === value));
    }
    if (rz.isArray(value) && value[0] && rz.isString(value[0])) {
      rowData = allRows.filter((rr) => (rz.arrContains(value, rr[keyField])));
    }
    if (rz.isArray(value) && value[0] && rz.isObject(value[0])) {
      rowData = allRows.filter((rr) => (rz.arrContains(value.map((vv) => (vv[keyField])), rr[keyField])));
    }
    if (rz.isObject(value) && value[keyField]) {
      rowData = allRows.filter((rr) => (value[keyField] === rr[keyField]));
    }
    if (!rowData || !rowData.length) { return [] }
    const pRows = rz.cascaderPath({allRows, rowData, method: "pathArray", lng, keyField: "tgr_key", parentField: "parent", titleField: "tgr_key"});
    const paths = (rz.isArray(pRows) ? (pRows as Array<{[key:string]:any}>).map((rr) => (rr.path)) : [(pRows as {[key:string]:any}).path]);
    return paths;
  }, [value, allRows, lng, keyField]);

  const [myValues, setMyValues] = useState(initValues);

  const onChange = useCallback((val) => {
    // console.log({appkey, value, val, column, rowIndex, cascaderTree});
    setMyValues(val);
    if (specialCellEditorOnChange) { specialCellEditorOnChange({appkey, aggridkey, gridRef, fullPath, controlType: "cascader", keyField, parentField, titleField, value: val, items: cascaderTree, column, rowIndex, lng, user, node, saveToDatabase, safe}) }
    else { onValueChange(val) }
    if (!multiple) { stopEditing() }
  }, [onValueChange, appkey, aggridkey, gridRef, fullPath, keyField, parentField, titleField, cascaderTree, column, rowIndex, lng, user, multiple, specialCellEditorOnChange, stopEditing, node, saveToDatabase, safe]);

  useEffect(() => {
    // let startValue;
    // if (eventKey === "Backspace") { startValue = "" }
    // else if (eventKey && eventKey.length === 1) { startValue = eventKey }
    // else { startValue = value }
    // if (!startValue) { startValue = "" }
    // updateValue(startValue);
    // @ts-ignore
    if (refCascade?.current) { refCascade.current.focus() }
  }, []);

  /* const filterOption = useCallback((inputValue:string, option:any) => {
    let item = (rz.isObject(option) ? (option.title || option.label || option.value || option.key) : (option || ""));
    if (rz.isObject(item) && item.props && item.props.children && item.props.children.length) { // If we have a ReactElement inside 'option'
      const chlds = item.props.children.filter((ch) => (ch && ch.props && ch.props.children && rz.isString(ch.props.children))).map((ch) => (ch.props.children));
      if (chlds && chlds.length) { item = chlds[0] }
    }
    return rz.strCompare(item, inputValue, ".caseNoSensitive.toLowerCase.trim.substring");
  }, []); */

  // console.log({cascaderTree, myValues});

  return (
    loading
      ? (<Skeleton loading={loading} active />)
      : (<Cascader
          options={cascaderTree}
          value={myValues}
          // defaultValue={myValues}
          onChange={onChange}
          multiple={Boolean(multiple)}
          changeOnSelect={!rz.isUndefinedOrNull(changeOnSelect) ? changeOnSelect : true}
          allowClear={rz.isUndefinedOrNull(allowClear) ? true : allowClear}
          autoFocus={rz.isUndefinedOrNull(autoFocus) ? true : autoFocus}
          open={true}
          variant={"outlined"}
          maxTagCount={100}
          ref={refCascade}
          className={"rz-width-1-1 rz-child-width-1-1"}
          placeholder={placeholder}
          uk-tooltip={tooltip}
          style={{minWidth: 200}}
      />)
  );
});
/* eslint-enable @typescript-eslint/no-unused-vars */
